@if (order) {
	@if (forbiddenEdit()) {
		@if (order.status.id == orderStatus.Submitted) {
			<div class="flex center padding bg-orange">
				<i class="fa fa-circle-info margin-right-smallest"></i>
				Order is submitted. Data editing is not available.
			</div>
		} @else if (order.status.id == orderStatus.ShootCompleted) {
			<div class="flex center padding bg-green white">
				<i class="fa fa-circle-info margin-right-smallest"></i>
				Shoot is completed. Data editing is not available.
			</div>
		}
	}

	<div class="padding-large m-padding">
		<div class="page-layout-small">
			<div class="flex between m-column m-start">
				<div class="flex center">
					<h4>Order Informations</h4>
				</div>

				<div class="flex center m-full-width m-margin-top">
					<button class="m-flex-1 {{ forbiddenEdit() ? 'disabled' : '' }}" (click)="saveChanges()">
						<mat-icon class="small margin-right-smallest">save</mat-icon>
						Save changes
					</button>
				</div>
			</div>
			<div class="flex column border radius margin-top">
				@if (!isNew) {
					<div class="bg-lightest-blue padding-large m-padding">
						<div class="grid-filter">
							<div class="flex column">
								<b>Order ID</b>
								<div class="margin-top-smallest bg-white padding-small">
									<h4>{{ order?.id }}</h4>
								</div>
							</div>

							<div class="flex column">
								<b>Status</b>
								<div class="flex margin-top-smallest">
									<div class="flex-1 bg-white padding-small">
										<h4 class="normal primary">{{ order?.status?.name }}</h4>
									</div>
									<!-- <button type="button" class="radius-left-none {{ forbiddenEdit() ? 'disabled' : '' }}" (click)="openStatusModal()">
										<i class="fa fa-solid fa-repeat"></i>
										Change
									</button> -->
								</div>
							</div>
						</div>
					</div>

					@if (order?.waybill?.shippingDate) {
						<div class="bg-lightest-blue padding-right-large padding-left-large padding-bottom-large">
							<div class="grid-filter">
								<div class="flex column">
									<b>Shipping date</b>
									<div class="flex margin-top-smallest bg-white padding-small primary">
										<h4>{{ order?.waybill?.shippingDate | date: 'dd/MM/yyyy' }}</h4>
									</div>
								</div>

								<div class="flex column">
									<b>Waybill details</b>
									<div class="flex margin-top-smallest">
										<div class="flex-1 bg-white padding-small primary">
											<h4>{{ order?.waybill?.waybillNumber }}</h4>
										</div>
										<button type="button" class="radius-left-none" (click)="downloadShippingLabel()">
											<i class="fa fa-download"></i>
											Download
											<span class="grey margin-left-smallest">(.pdf)</span>
										</button>
									</div>
								</div>
							</div>
						</div>
					}
				}

				<div class="padding-large m-padding">
					<div class="grid-filter">
						<div class="flex-1 flex column">
							<div class="flex center between">
								<b>
									Photographer
									@if (!orderValidation.photographer) {
										<span class="red margin-left">Required field</span>
									}
								</b>
								<button type="button" class="radius-bottom-none {{ forbiddenEdit() ? 'disabled' : '' }}" (click)="openEditPhotographerModal(); orderValidation.photographer = true">
									<i class="fa-solid fa-edit"></i>
									Edit
								</button>
							</div>
							<div class="border blue padding flex center">
								@if (order?.photographer) {
									<div class="placeholder bg-primary white">
										<i class="fa fa-user"></i>
									</div>
									<div class="flex column margin-left-small">
										{{ order?.photographer?.fullName }}
										<div class="flex center primary hover margin-top-smallest disabled">
											View Details
											<i class="fa-solid fa-arrow-up-right-from-square margin-left-smallest"></i>
										</div>
									</div>
								} @else {
									Select a photographer
								}
							</div>

							<div class="flex column margin-top">
								<b>Order type</b>
								<div class="flex center margin-top-smallest {{ forbiddenEdit() ? 'disabled' : '' }}">
									<div class="flex gap center">
										@for (type of orderTypes; track type) {
											<div class="flex center column {{ type.selected ? 'border bg-lightest-blue' : '' }} padding-small hover " (click)="selectOrderType(type)">
												<div class="flex-1">
													<div class="placeholder {{ type.name }}"></div>
												</div>

												<div class="flex-0 flex column margin-top-smallest">
													<b>{{ type.name }}</b>
												</div>
											</div>
										}
									</div>
								</div>
							</div>

							<div class="flex column margin-top">
								<b>
									Creation date
									<i class="margin-left-smallest fa fa-lock grey"></i>
								</b>
								<div class="flex margin-top-smallest disabled">
									<input type="text" class="flex-1" [matDatepicker]="creationDatePicker" matInput [(ngModel)]="order.creationDate" />
									<mat-datepicker #creationDatePicker></mat-datepicker>
									<button class="radius-left-none" (click)="creationDatePicker.open()">
										<mat-icon class="small margin-right-smallest">calendar_month</mat-icon>
										Edit
									</button>
								</div>
							</div>

							<div class="flex column margin-top">
								<b>
									Due date
									@if (!orderValidation.dueDate) {
										<span class="red margin-left">Required field</span>
									}
								</b>
								<div class="flex margin-top-smallest">
									<input type="text" class="flex-1" [matDatepicker]="dueDatePicker" matInput [min]="todayDate" [(ngModel)]="order.dueDate" />
									<mat-datepicker #dueDatePicker></mat-datepicker>
									<button class="radius-left-none {{ forbiddenEdit() ? 'disabled' : '' }}" (click)="dueDatePicker.open(); orderValidation.dueDate = true">
										<mat-icon class="small margin-right-smallest">calendar_month</mat-icon>
										Edit
									</button>
								</div>
							</div>
						</div>
						<div class="flex-1 flex column">
							<b>Notes</b>
							<textarea class="full-height full-width margin-top-smallest" matInput [(ngModel)]="order.notes" style="resize: none; overflow: auto"></textarea>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
}
@if (loading) {
	<bt-loader></bt-loader>
}
